/**
 * @generated SignedSource<<f21712bb6312c2ab534451cec89bb008>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type UserRedirectScreenQuery$variables = Record<PropertyKey, never>;
export type UserRedirectScreenQuery$data = {
  readonly currentUser: {
    readonly onboardedAt: any | null | undefined;
    readonly rowId: any;
    readonly status: UserStatus;
  } | null | undefined;
};
export type UserRedirectScreenQuery = {
  response: UserRedirectScreenQuery$data;
  variables: UserRedirectScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboardedAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserRedirectScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserRedirectScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96d32ac8de2951d2b7ed9f261707a412",
    "id": null,
    "metadata": {},
    "name": "UserRedirectScreenQuery",
    "operationKind": "query",
    "text": "query UserRedirectScreenQuery {\n  currentUser {\n    onboardedAt\n    status\n    rowId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8d5c9ac915648c3bc1a7877f8165d38";

export default node;
